<div class="flex w-full h-full p-6 gap-6 bg-surface-50 flex-col">
  <div class="flex gap-6 items-start">
  <p-card class="flex-1">
    <div class="flex flex-col gap-4">
      <div class="flex gap-2 items-center">
        <input type="text"
               pInputText
               [(ngModel)]="searchStr"
               class="w-1/3"
               pSize="small"
               data-testid="user-admin-search"
               placeholder="Search by name or email..."
               (keydown.enter)="runSearch()"
        />
        <p-button label="Search" size="small" icon="fa fa-magnifying-glass"
                  (onClick)="runSearch()" />
        <div class="bg-white rounded">
          <p-button label="Clear" size="small" severity="secondary" outlined
                    icon="fa fa-x" (onClick)="clear()" />
        </div>
        <div class="flex-1"></div>
      </div>

      @if (hasSearched() && userList().length > 0) {
        <div class="text-xs text-slate-500">
          Showing {{userList().length}} of {{totalCount()}} results
        </div>
        <div #scrollContainer scrollHeight class="rounded-lg border-[1px] border-surface-300 overflow-y-auto">
          <p-table [value]="userList()"
                   size="large"
                   [tableStyle]="{'overflow': 'visible', 'min-width': '50rem'}"
          >
            <ng-template #header>
              <tr class="sticky">
                <th>Name</th>
                <th>Type</th>
                <th>Email</th>
                <th>Groups</th>
                <th>Tier</th>
                <th>Status</th>
                <th>Can Submit TAs</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template #body let-rowData>
              <tr>
                <td  [class.bg-yellow-50]="rowData.userType === UserType.Casual">{{rowData.name}} {{getUserTypeSuffix(rowData)}}</td>
                <td>{{rowData.userType}}</td>
                <td>{{rowData.email}}</td>
                <td>{{getGroupStr(rowData.permissionSummary.groups)}}</td>
                <td><span class="text-nowrap">{{tierMap().get(rowData.tierId)?.name ?? '-'}}</span></td>
                <td>
                  @if (rowData.isActive) {
                    <p-tag severity="info" rounded value="Active" />
                  } @else {
                    <p-tag severity="danger" rounded value="Inactive" />
                  }
                </td>
                <td>
                  @if (!rowData.isActive || rowData.isEnabled === false) {
                    <p-tag severity="danger" rounded value="No" />
                  } @else {
                    <p-tag severity="info" rounded value="Yes" />
                  }
                </td>
                <td>
                  <p-button class="edit" size="small" (onClick)="openEditUserModal(rowData)">
                    <span>Edit</span>
                    <i class="fa-light fa-pencil"></i>
                  </p-button>
                </td>
              </tr>
            </ng-template>
          </p-table>

          @if (canLoadMore()) {
            <div #loadMoreSentinel class="flex items-center justify-center gap-3 py-3">
              <p-button label="Load More"
                        severity="secondary"
                        size="small"
                        icon="fa fa-arrow-down"
                        [disabled]="isSearching()"
                        (onClick)="loadMore()">
              </p-button>
            </div>
          }
        </div>
      } @else if (hasSearched() && userList().length === 0) {
        <div class="pl-2 text-slate-900 text-sm font-normal font-['Inter'] leading-6 italic">No users match this search.</div>
      } @else {
        <div class="pl-2 text-slate-500 text-sm font-normal font-['Inter'] leading-6">Use the search above to view users.</div>
      }
    </div>
  </p-card>

  @if (canManageUsers && userList().length == 0) {
    <p-card class="w-[45%]">
      <div class="flex flex-col gap-3">
        <div class="flex gap-4 items-center">
          <p-button label="Entra&nbsp;ID&nbsp;Refresh"
                    [icon]="isRefreshRunning() ? 'fa fa-arrows-rotate fa-spin' : 'fa fa-arrows-rotate'"
                    iconPos="right"
                    [disabled]="!jobStatusLoaded() || isRefreshRunning()"
                    data-testid="entra-refresh-button"
                    (onClick)="triggerEntraRefresh()" />
          <div class="text-sm italic text-slate-700">Manually refresh TAP's user information from the Entra ID server.</div>
        </div>
        @if (!jobStatusLoaded()) {
          <div class="text-sm text-slate-500 italic">Checking refresh status&hellip;</div>
        } @else if (isRefreshRunning()) {
          <div class="text-sm text-slate-500 italic">Refresh in progress&hellip;</div>
        } @else if (jobStatus()?.status === JobRunStatus.Success) {
          <div class="text-sm text-green-700">Last refresh {{ jobStatus()?.lastEnded | date:'dd/MM/yy h:mm:ss a' }} - Successful refresh</div>
        } @else if (jobStatus()?.status === JobRunStatus.Failed || jobStatus()?.status === JobRunStatus.Interrupted) {
          <div class="text-sm text-red-700">Last refresh {{ (jobStatus()?.lastEnded ?? jobStatus()?.lastStarted) | date:'dd/MM/yy h:mm:ss a' }} - Failed refresh</div>
        }
      </div>
    </p-card>
  }
  </div>
  <div class="p-2.5 w-full"></div>
</div>
